function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".timer{fill:#ee3f5c;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-13.3 -13.3)"
}, /*#__PURE__*/React.createElement("path", {
  className: "timer",
  d: "M43.991,13.3A30.691,30.691,0,1,0,74.683,43.991,30.692,30.692,0,0,0,43.991,13.3Zm0,58.477A27.786,27.786,0,1,1,71.777,43.991,27.824,27.824,0,0,1,43.991,71.777Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "timer",
  d: "M64.506,51V34.053a1.453,1.453,0,1,0-2.906,0V51.608a1.58,1.58,0,0,0,.424,1.029L73.707,64.32a1.461,1.461,0,0,0,2.058,0,1.5,1.5,0,0,0,0-2.058Z",
  transform: "translate(-19.062 -7.617)"
}));

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.383,
    height: 61.383,
    viewBox: "0 0 61.383 61.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.da78a23d.svg";
export { ForwardRef as ReactComponent };